import { LineItem } from 'shared/types/cart';

export const lineItemHasExpiredPhotos = (
  lineItem: LineItem
) => {
  const expirationDate = lineItem.imageMetadata?.expirationDate;
  const expirationTime = expirationDate ? new Date(expirationDate).getTime() : undefined;
  return lineItemHasPhoto(lineItem) && (!expirationTime || expirationTime < Date.now());
};

export const lineItemHasPhoto = (lineItem: LineItem) => {
  const id = lineItem.imageMetadata?.id;
  return typeof id === 'string' && id.length > 0;
};
